import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    flexCenter: {
        display: 'flex',
    },
    paper: {
        marginTop: '16px',
        marginBottom: 0,
        padding: '16px',
        paddingBottom: '8px',
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        minHeight: '42px',
    },
    currentFiltersWrapper: {
        padding: '16px',
        paddingTop: '8px',
    },
    filtersWrapper: {
        marginBottom: '16px',
    },
}));
